import { render, staticRenderFns } from "./SlideListGrandchild.vue?vue&type=template&id=04a4b438&scoped=true&"
import script from "./SlideListGrandchild.vue?vue&type=script&lang=js&"
export * from "./SlideListGrandchild.vue?vue&type=script&lang=js&"
import style0 from "./SlideListGrandchild.vue?vue&type=style&index=0&id=04a4b438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4b438",
  null
  
)

export default component.exports